export {
  setLang,
  setTranslations,
  getActiveCountry,
  setActiveCountry,
  getActiveLang,
  getActiveLocale,
  getUrlLocale,
  onReady,
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  translate,
} from './i18nService';

export { default as useI18n } from './hooks/useI18n';
export { default as initI18n } from './services/initI18n';
export { default as Translate } from './components/Translate';
